<template>
  <nav class="nav flex-column p-3">
    <menu-item v-for="(r,i) in routes" :key="i" :route="r"></menu-item>
  </nav>
</template>

<script>
import MenuItem from './MenuItem';

export default {
  name: "Navigation",

  components: {
    MenuItem,
  },

  computed: {
    routes() {
      return this.$router.options.routes;
    },
  },

};
</script>
